import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import FlowAdministrationLayout from "../layouts/FlowAdministrationLayout";
import JeuneInnovateurLayout from "../layouts/JeuneInnovateurLayout";
import InvestisseurLayout from "../layouts/InvestisseurLayout";
import VisiteurLayout from "../layouts/VisiteurLayout";
import MentorLayout from "../layouts/MentorLayout";
import { UserRoles } from "@/types/enums/actors-types";

type PrivateRouteProps = {
  requiredRole:
    | UserRoles.ADMIN
    | UserRoles.INVESTISSEUR
    | UserRoles.MEMBER
    | UserRoles.MENTOR
    | UserRoles.VISITEUR;
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ requiredRole }) => {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (user.role != requiredRole) {
    return <Navigate to="/" />;
  }

  // Choose layout based on role
  let Layout;
  switch (user.role) {
    case UserRoles.MEMBER:
      Layout = JeuneInnovateurLayout;
      break;
    case UserRoles.VISITEUR:
      Layout = VisiteurLayout;
      break;
    case UserRoles.INVESTISSEUR:
      Layout = InvestisseurLayout;
      break;
    case UserRoles.ADMIN:
      Layout = FlowAdministrationLayout;
      break;
    case UserRoles.MENTOR:
      Layout = MentorLayout;
      break;
    default:
      return <Navigate to="/" />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default PrivateRoute;
